import React from 'react';
import { useTranslation } from 'react-i18next';

/** Right column: "On this page", with the heading in view highlighted. */
export default function HelpToc({ headings, activeId, onJump }) {
  const { t } = useTranslation();
  if (!headings?.length) return null;
  return (
    <nav aria-label={t('help.onThisPage')}>
      <h6>{t('help.onThisPage')}</h6>
      {headings
        .filter((h) => h.level <= 3)
        .map((h) => (
          <button
            key={h.id}
            type="button"
            className={`help-toc-item${h.level === 3 ? ' help-toc-item--sub' : ''}${h.id === activeId ? ' help-toc-item--on' : ''}`}
            aria-current={h.id === activeId ? 'location' : undefined}
            onClick={() => onJump(h.id)}
          >
            {h.text}
          </button>
        ))}
    </nav>
  );
}
